class ProgressRating {
  static init() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const fill = entry.target.querySelector(".progress-fill");
            if (fill) {
              fill.style.width = `${(fill.dataset.score / 10) * 100}%`;
            }
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll("[data-progress]").forEach((element) => {
      try {
        const data = JSON.parse(element.dataset.progress);
        const labelPosition = element.dataset.labelPosition || "above";
        this.create(element, data, labelPosition);
      } catch (e) {
        console.error("Invalid progress data:", e);
      }
    });
  }

  static create(container, items, labelPosition) {
    if (typeof container === "string") {
      container = document.getElementById(container);
    }

    if (!container) {
      console.error("Container not found");
      return;
    }

    items.forEach((item) => {
      const bar = document.createElement("div");
      bar.className = "progress-bar";
      
      if (labelPosition === "inside") {
        bar.innerHTML = `
          <div class="progress-track">
              <div class="progress-header">
                  <span class="progress-score">${item.score}</span><span class="progress-score-slash">/</span><span class="progress-score">10</span>
                  <span class="progress-label">${item.label}</span>
              </div>
              <div class="progress-fill" data-score="${item.score}">&nbsp;</div>
          </div>
        `;
      } else {
        const label = document.createElement("div");
        label.className = "progress-label above";
        label.textContent = item.label;
        
        bar.innerHTML = `
          <div class="progress-track-wrapper">
            <div class="progress-track">
                <div class="progress-header">
                    <span class="progress-score">${item.score}</span><span class="progress-score-slash">/</span><span class="progress-score">10</span>
                </div>
                <div class="progress-fill" data-score="${item.score}">&nbsp;</div>
            </div>
          </div>
        `;
        
        bar.prepend(label);
      }
      
      container.appendChild(bar);
      this.observer.observe(bar.querySelector(".progress-track"));
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  ProgressRating.init();
});
